import { useCallback, useContext } from "react";
import SelectEntitiesContext from "components/common/EntityDataTable/contexts/SelectEntitiesContext";
const useDeselectEntities = () => {
  const selectEntitiesContext = useContext(SelectEntitiesContext);
  return useCallback(
    (entityIds) => {
      if (!selectEntitiesContext) return;
      const { selectedEntities, setSelectedEntities } = selectEntitiesContext;
      const deselectedIds = new Set(entityIds);
      setSelectedEntities(selectedEntities.filter((entityId) => !deselectedIds.has(entityId)));
    },
    [selectEntitiesContext]
  );
};
export default useDeselectEntities;
